import { bitbucketConnectRequestSchema, bitbucketConnectResultSchema, bitbucketDisconnectResultSchema, bitbucketImportedUsersResultSchema, bitbucketStatusResponseSchema, bitbucketSyncResultSchema, bitbucketSyncStatusResponseSchema, bitbucketUpdateTokenRequestSchema, bitbucketUpdateTokenResultSchema, } from '../contracts/bitbucket';
import { organizationIdSchema } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * Get Bitbucket integration status for an organization
 */
export async function getBitbucketStatus(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/bitbucket/status`);
    return parseSchema(bitbucketStatusResponseSchema, response);
}
/**
 * Connect a Bitbucket workspace with a workspace access token
 */
export async function connectBitbucket(client, organizationId, data) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedData = parseSchema(bitbucketConnectRequestSchema, data);
    const response = await client.post(`/organizations/${validatedId}/bitbucket/connect`, validatedData);
    return parseSchema(bitbucketConnectResultSchema, response);
}
/**
 * Disconnect Bitbucket integration from an organization
 */
export async function disconnectBitbucket(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.post(`/organizations/${validatedId}/bitbucket/disconnect`);
    return parseSchema(bitbucketDisconnectResultSchema, response);
}
/**
 * Update (rotate) the Bitbucket workspace access token
 * Validates that the new token is for the same workspace
 */
export async function updateBitbucketToken(client, organizationId, data) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedData = parseSchema(bitbucketUpdateTokenRequestSchema, data);
    const response = await client.put(`/organizations/${validatedId}/bitbucket/update-token`, validatedData);
    return parseSchema(bitbucketUpdateTokenResultSchema, response);
}
/**
 * Trigger a manual sync of Bitbucket workspace members
 */
export async function syncBitbucket(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.post(`/organizations/${validatedId}/bitbucket/sync`);
    return parseSchema(bitbucketSyncResultSchema, response);
}
/**
 * Get Bitbucket sync status for an organization
 */
export async function getBitbucketSyncStatus(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/bitbucket/sync-status`);
    return parseSchema(bitbucketSyncStatusResponseSchema, response);
}
/**
 * Get imported users from Bitbucket for an organization
 */
export async function getBitbucketImportedUsers(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/bitbucket/imported-users`);
    return parseSchema(bitbucketImportedUsersResultSchema, response);
}
//# sourceMappingURL=bitbucket.js.map